"use client";

const Table = ({
  columns,
  data,
  onRowClick,
  isLoading = false,
  emptyState = "No data available",
}) => {
  if (isLoading) {
    return (
      <div className="bg-white overflow-hidden shadow rounded-lg">
        <div className="animate-pulse">
          <div className="border-b border-gray-200">
            <div className="px-6 py-3 flex space-x-4">
              {columns.map((column, idx) => (
                <div key={idx} className="h-4 bg-gray-200 rounded w-1/4"></div>
              ))}
            </div>
          </div>
          <div className="divide-y divide-gray-200">
            {[...Array(5)].map((_, idx) => (
              <div key={idx} className="px-6 py-4 flex space-x-4">
                {columns.map((column, colIdx) => (
                  <div
                    key={colIdx}
                    className="h-4 bg-gray-200 rounded w-1/4"
                  ></div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="bg-white overflow-hidden shadow rounded-lg">
        <div className="px-4 py-5 sm:p-6 text-center text-gray-500">
          {emptyState}
        </div>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            {columns.map((column, idx) => (
              <th
                key={idx}
                scope="col"
                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
              >
                {column.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {data.map((row, rowIdx) => (
            <tr
              key={rowIdx}
              className={onRowClick ? "cursor-pointer hover:bg-gray-50" : ""}
              onClick={onRowClick ? () => onRowClick(row) : undefined}
            >
              {columns.map((column, colIdx) => (
                <td key={colIdx} className="px-6 py-4 whitespace-nowrap">
                  {column.cell ? column.cell(row) : row[column.accessor]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
